import React from 'react';
import {
  Button,
  FormControl,
  TableBody,
  TableCell,
  TableRow,
} from '@mui/material';
import PropTypes from 'prop-types';
import AddIcon from '@mui/icons-material/Add';
import useStyles from './styles';
import MultiplierInput from '../AddAssociationForm/MultiplierInput';
import ProductAssociationSelect from '../AddAssociationForm/ProductAssociationSelect';
import Loader from '../../../../../../../commons/Loader';
import { groupsCustom } from '../../../../../../../../utils/custom_prop_types/customPropTypes';

export default function TableContent({
  groups,
  setErrorMessage,
  setOpenModal,
  selectedProductAssociation,
  setSelectedProductAssociation,
  setTypedMultiplier,
}) {
  const classes = useStyles();

  const handleAddButtonSubmit = (event) => {
    event.preventDefault();
    setErrorMessage([]);
    setOpenModal('addAssociationConfirmation', true);
  };

  return (
    <TableBody>
      <TableRow>
        <FormControl className={classes.formControl}>
          <form onSubmit={(event) => handleAddButtonSubmit(event)}>
            <TableCell>
              <MultiplierInput setTypedMultiplier={setTypedMultiplier} />
            </TableCell>
            <TableCell>
              <ProductAssociationSelect
                associationGroups={groups}
                selectedProductAssociation={selectedProductAssociation}
                setSelectedProductAssociation={setSelectedProductAssociation}
              />
            </TableCell>
            <TableCell>
              <Button
                type="submit"
                className={classes.button}
                variant="contained"
                color="secondary"
                startIcon={<AddIcon />}
              >
                Add Association
              </Button>
            </TableCell>
          </form>
        </FormControl>
      </TableRow>
      <Loader target="singleAssociation" size={32} centeredX centeredY />
    </TableBody>

  );
}

TableContent.defaultProps = {
  selectedProductAssociation: null,
};

TableContent.propTypes = {
  groups: groupsCustom.isRequired,
  setErrorMessage: PropTypes.func.isRequired,
  setOpenModal: PropTypes.func.isRequired,
  selectedProductAssociation: PropTypes.string,
  setSelectedProductAssociation: PropTypes.func.isRequired,
  setTypedMultiplier: PropTypes.func.isRequired,
};
